import API from "./API/utils/errorHandler/register";
function autobind(context) {
    Object.getOwnPropertyNames(Object.getPrototypeOf(context)).forEach(function (prop) {
        var dontBind = prop === "constructor" || typeof context[prop] !== "function";
        if (!dontBind) {
            context[prop] = context[prop].bind(context);
        }
    });
}
var PBService = /** @class */ (function () {
    function PBService(props) {
        autobind(this);
        props.errorHandlers.forEach(function (handler) {
            API.add(handler);
        });
    }
    return PBService;
}());
export default PBService;
